export const socialsData = {
    github: 'https://github.com/rishianand39',
    linkedIn: 'https://www.linkedin.com/in/rishianand39/',
    stackOverflow: 'https://stackoverflow.com/users/18836476/rishi-anand?tab=profile',
    twitter:"https://twitter.com/rishianand39",
    // codepen: 'https://codepen.io/sarkarsubho',

}